import type { CatalogueEntry } from "../types";
import imageLight from "../images/town-points.light.webp";
import imageDark from "../images/town-points.dark.webp";

export const entry: CatalogueEntry = {
  slug: "town-points",
  displayName: `Town Points`,
  datasetProductCode: `TOWN POINTS`,
  subtitle: `Graphical Representation of Small Population Areas.`,
  shortDescription: `Town Points is a digital representation of Australia's towns, represented as points. This dataset provides an optimised aggregated national view of Town Point geometry and attribution. The dataset is created from multiple sources including ABS and jurisdictional data.
Town Points is designed to meet the needs of organisations that require a graphical representation of towns to integrate with other data in servicing their business needs.`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Points"],
    totalFeatureCount: 1977,
    updateFrequency: `No Longer Updated`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/townpoints.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/townpoints.html`,
  imageLight,
  imageDark,
  searchTags: `Town Points Community Planning Population Insights Rural Rural Development Settlements Small Towns Towns`,
  detail: () => import("../details/town-points").then((m) => m.detail),
};

export default entry;
